/**
 * Quiet fullscreen placeholder used during route transitions where we
 * don't yet know the final destination. Intentionally has NO visible
 * spinner — Nic's feedback: when a load takes long enough that a spinner
 * shows up over an otherwise empty page it reads as "the app is broken
 * and stuck", not as "the app is loading". A plain white screen reads
 * as "the page hasn't painted yet", which is closer to the truth.
 *
 * Used by:
 *   - ProtectedRoute / OnboardingRoute while auth + onboarding status load
 *   - OnboardingStart / OnboardingWelcome / OnboardingMobile while status loads
 *   - AuthCallback while it decides where to send the user
 *
 * Do NOT use this on the Saved/Settings/Upgrade pages themselves — those
 * have their own destination-aware loading states (e.g. Saved's skeleton)
 * that DO match the page the user is about to see.
 */
export function RouteLoader() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className="fixed inset-0 z-40 bg-white"
    />
  );
}
